export const API_BASE_URL =
  "https://api.cashbackpromoters.com/api/v1/";


// export const API_BASE_URL =
//   "http://localhost:5400/api/v1/";

export const API_PATHS = {

  uploadFile: "admin/upload",


  userlogin: "login",
  register: "register",
  verifyotp: "verifyOtp",
  getProfile: "getprofile",
  getTeam: "get-team-tree",
  getWallet: "get-wallet-transaction-history",
  saveBankDetails: "saveBankDetails",
  getBankDetails: "getBankDetails",
  editBankDetails: "editBankDetails",
  deleteBankDetails: "deleteBankDetails",
  forgotpassword: "forgotpassword",
  setpassword: "setpassword",
  requestWithdrawal: "requestWithdrawal",
  getWithdrawalRequests: "getWithdrawalRequests",
  approveWithdrawal: "admin/approveWithdrawal",
  rejectWithdrawal: "admin/rejectWithdrawal",

  addProject: "admin/add-project",
  getProject: "admin/get-project",
  editProject: "admin/edit-project",
  projectDelete: "admin/delete-project",
  getGallery: "admin/get-gallery",
  addGallery: "admin/add-gallery",
  deleteGallery: "admin/delete-gallery",
  getuserWallet: "admin/get-wallet-transaction-history",

  getusers: "admin/get-user",
  approveuser: "admin/approve-user",

  getluckydraw: "admin/get-lucky-draw",
  addLuckydraw: "admin/add-lucky-draw",

  getuserluckydraw: "get-lucky-draw",
  getluckydrawentries: "admin/get-lucky-draw-entries",
  approveluckydrawentry: "admin/approve-lucky-draw-entry",
  joinluckydraw: "join-lucky-draw",
  myluckydraw: "my-lucky-draw",


  addSite: "admin/add-site",
  editSite: "admin/edit-site",
  getSite: "admin/get-site",
  deleteSite: "admin/delete-site",
  getBankAccount: "admin/get-bank-account",
  approveBankAccount: "admin/approveBankAccount"




};
